import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { PushNotificationProvider } from "./contexts/PushNotificationContext";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/layout/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import MallGroupsPage from "./pages/MallGroupsPage";
import MallsPage from "./pages/MallsPage";
import MallDetailPage from "./pages/MallDetailPage";
import MallManagementPage from "./pages/MallManagementPage";
import MallPreLeasingPage from "./pages/MallPreLeasingPage";
import MallPostLeasingPage from "./pages/MallPostLeasingPage";
import MallOperationsPage from "./pages/MallOperationsPage";
import OperationsSelectPage from "./pages/OperationsSelectPage";
import InventoryPage from "./pages/InventoryPage";
import DigitalTwinPage from "./pages/DigitalTwinPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import UsersPage from "./pages/UsersPage";
import AIInsightsPage from "./pages/AIInsightsPage";
import SettingsPage from "./pages/SettingsPage";
import TenantPortalPage from "./pages/TenantPortalPage";
import LeasingCRMPage from "./pages/LeasingCRMPage";
import LeaseDocumentsPage from "./pages/LeaseDocumentsPage";
import ProposalBuilderPage from "./pages/ProposalBuilderPage";
import PreLeasingDashboardPage from "./pages/PreLeasingDashboardPage";
import PostLeasingDashboardPage from "./pages/PostLeasingDashboardPage";
import MobileStaffPage from "./pages/MobileStaffPage";
import QRCodeManagementPage from "./pages/QRCodeManagementPage";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <PushNotificationProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Routes>
                      <Route path="/" element={<DashboardHome />} />
                      <Route path="/groups" element={<MallGroupsPage />} />
                    <Route path="/malls" element={<MallsPage />} />
                    <Route path="/malls/:mallId" element={<MallDetailPage />} />
                    <Route path="/mall/:mallId/manage" element={<MallManagementPage />} />
                    <Route path="/mall/:mallId/pre-leasing" element={<MallPreLeasingPage />} />
                    <Route path="/mall/:mallId/post-leasing" element={<MallPostLeasingPage />} />
                    <Route path="/mall/:mallId/operations" element={<MallOperationsPage />} />
                    <Route path="/operations" element={<OperationsSelectPage />} />
                    <Route path="/inventory" element={<InventoryPage />} />
                    <Route path="/digital-twin" element={<DigitalTwinPage />} />
                    <Route path="/digital-twin/:mallId" element={<DigitalTwinPage />} />
                    <Route path="/analytics" element={<AnalyticsPage />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/ai-insights" element={<AIInsightsPage />} />
                    <Route path="/tenant-portal" element={<TenantPortalPage />} />
                    <Route path="/leasing" element={<LeasingCRMPage />} />
                    <Route path="/documents" element={<LeaseDocumentsPage />} />
                    <Route path="/proposals" element={<ProposalBuilderPage />} />
                    <Route path="/pre-leasing" element={<PreLeasingDashboardPage />} />
                    <Route path="/post-leasing" element={<PostLeasingDashboardPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/mobile" element={<MobileStaffPage />} />
                    <Route path="/mall/:mallId/qr-codes" element={<QRCodeManagementPage />} />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: 'hsl(var(--card))',
            color: 'hsl(var(--foreground))',
            border: '1px solid hsl(var(--border))',
          },
        }}
      />
      </PushNotificationProvider>
    </AuthProvider>
  );
}

export default App;
